import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import createSagaMiddleware from 'redux-saga';
import { persistStore, persistCombineReducers } from 'redux-persist';
import storage from 'redux-persist/es/storage';
import { PersistGate } from 'redux-persist/es/integration/react';
import Loadable from 'react-loadable';

/**
 * Redux chung
 */
import routerReducers from './redux/reducers';
import routerReducersStatic from './redux/routerReducersStatic';
import rootSaga from './redux/saga/rootSaga';
import('./Pc.css');


function getParams(query) {
    if (!query) {
        return {};
    }
    return (/^[?#]/.test(query) ? query.slice(1) : query)
        .split('&')
        .reduce((params, param) => {
            let [key, value] = param.split('=');
            params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
            return params;
        }, {});
}

const config = {
    key: 'root_' + getParams(window.location.search).webId,
    storage,
};

const sagaMiddleware = createSagaMiddleware();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const reducersStorage = combineReducers({
    state: routerReducers,
    stateStatic: persistCombineReducers(config, { static: routerReducersStatic }),
    // router: routerReducer,
});

const store = createStore(
    reducersStorage,
    composeEnhancers(applyMiddleware(sagaMiddleware))
);
sagaMiddleware.run(rootSaga);

let persistor = persistStore(store, null, () => {

});


//Trước khi load hoàn thành
const onBeforeLift = () => { };


const LoadableBodyComponent = Loadable({
    loader: () => import('./components/layout/Body'),
    loading: () => <div id="loadFirt"><div className="loader"></div></div>,
});

ReactDOM.render(<Provider store={store}>
    <PersistGate
        loading={<div>
            Xin chào nhé
        </div>}
        onBeforeLift={onBeforeLift}
        persistor={persistor}>
        <LoadableBodyComponent />
    </PersistGate>
</Provider>, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js